import CourseController from '../../../../../components/diagrams/course.controller';
import drillingForMethane from './i18n/drillingForMethane';
import payoffFromProductManagement from './i18n/payoffFromProductManagement';
import theRationalizationProgram from './i18n/theRationalizationProgram';

class FindingReadersQuestionArgumentsController extends CourseController
{

  constructor ( courseService, helperService, $sce, $scope )
  {
    "ngInject";
    super( courseService, helperService, $sce, $scope );
    Object.assign( this, { helperService, $sce } );
    this.videoUrl = this.$sce.trustAsResourceUrl( 'https://player.vimeo.com/video/322764692' );

    this.videoId = '6645b442908c40ff9bfb451764117f08';

    this.lang = 'en';

    this.payoffFromProductManagement = payoffFromProductManagement[ this.lang ];
    this.theRationalizationProgram = theRationalizationProgram[ this.lang ];
    this.drillingForMethane = drillingForMethane[ this.lang ];
    this.isUnit = true;
    this.exerciseIdsStart = 'exercise';
    this.exerciseUserAnswers = {};

  }

}

export default FindingReadersQuestionArgumentsController;



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4b1/findingReadersQuestion/findingReadersQuestion.controller.js